export default "__VITE_ASSET__BvkOiuiA__"